module.exports = __webpack_public_path__ + "img/FLDCOMP.3424d9be.svg";